import actions from './actions';

const initState = {
  loadingInitData: false,
  currentOp: {},
  ops: [],
  paginationInfo: {},
  operarioId: null,
  permisoOperario: null,
  isLoadingOP: false,
};
export default (state = initState, action) => {
  switch (action.type) {
    case actions.SET_OPS:
      // let opOperario = [];
      // if (state.permisoOperario === 1) {
      //   action.payload.forEach(opData => {
      //     const evaluacion = opData.recursoHumanoProceso.findIndex(element => element.usuario_id[0] === state.operarioId);

      //     if (evaluacion >= 0) {
      //       opOperario.push(opData)
      //     }
      //   })

      // } else if (state.permisoOperario >= 4) {
      //   opOperario = action.payload;
      // }
      // console.log(action.payload);
      // console.log(opOperario);
      return {
        ...state,
        ops: action.payload,
        isLoadingOP: false,
      }
    case actions.DELETED_OP:
      return {
        ...state,
        ops: state.ops.filter(op => op._id !== action.payload),
      }
    case actions.EDIT_OPS:
      return {
        ...state,
        isLoadingOP: true,
      }
    case actions.SET_PAGINATION_INFO:
      return {
        ...state,
        paginationInfo: action.payload,
      }
    case actions.SET_OPERARIO:
      return {
        ...state,
        operarioId: action.payload,
      }
    case actions.SET_PERMISOS_OPERARIO:
      return {
        ...state,
        permisoOperario: action.payload,
      }
    case actions.UPDATE_OP_ESTADO:
      return {
        ...state,
        ops: state.ops.filter(op => op._id !== action.delete),
      }
    case actions.UPDATE_ETAPA:
      const ops = state.ops.map(op => {
        if (op._id === action.payload._id) {
          op.nuevaEtapa = action.payload.nuevaEtapa
        }
        return op;
      });


      return {
        ...state,
        ops
      }
    default:
      return state;
  }
};
